'use strict';
import isNumber from 'lodash/isNumber';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {NoteState} from '../../enums/NoteState';

export function BaseNotificationPanelButtonView(props) {
  if (!props.showButton) {
    return null;
  }

  const isProcessing = props.state === NoteState.PROGRESS || props.state === NoteState.INDEFINITE;

  return (
    <div
      className={classNames('NotificationPanelButton', props.className)}
      onClick={props.onClick}
    >
      <span className="NotificationPanelButton__label">
        {isProcessing ? props.processingCount : props.staticCount}
      </span>
      {isProcessing ? <i className="icon ion-load-c spin" /> : null}
    </div>
  );
}

BaseNotificationPanelButtonView.propTypes = {
  showButton: T.bool.isRequired,
  state: T.number,
  size: T.number,
  staticCount: T.string,
  processingCount: T.string,
  onClick: T.func,
};

export const NotificationPanelButtonView = I18nComponent(BaseNotificationPanelButtonView, [
  {code: 'notifications.current.static.count.button', prop: 'staticCount', params: getParams},
  {code: 'notifications.current.active.count.button', prop: 'processingCount', params: getParams},
]);

function getParams(props) {
  return {
    count: isNumber(props.size) ? props.size : 0,
  };
}



// WEBPACK FOOTER //
// ./src/js/system/components/NotificationPanelButton/NotificationPanelButtonView.js